export default __webpack_public_path__ + "static/media/i12.1561dd61.jpeg";